export function readEnv(env: string): string | undefined {
  if (typeof process !== "undefined" && process.env) {
    return process.env?.[env]?.trim() ?? undefined;
  }
  if (typeof window !== "undefined" && env in window) {
    return String(window[env as keyof typeof window]);
  }
  return undefined;
}
